
import React from 'react';
import { Icon } from 'rhombus-react';

export default function TargetingSheetExport(props){
	let message = ""
		, title = props.info.task.substring(props.info.task.indexOf(" ") + 1)
		, siteName = props.info.data.campaignSite?.site?.name ? ` for ${props.info.data.campaignSite.site.name}` : ""
		, campaignName = props.info.data?.campaign?.name || "Unknown Campaign"
		, error = props.info.error?.description || "Unknown"
		, { iconInfo = { icon: "", title: "" } } = props.info || {}
		;

	if(/in progress/gi.test(props.info.status)){
		message = <span>{title}{siteName} in progress</span>;
	}else if(/success/gi.test(props.info.status)){
		message = [
			<p key="message">{title}{siteName} is ready</p>
			, <a key="download-link" href={`${props.info.apiBase}${props.info.downloadLink}`} download target="_BLANK">Download Export</a>
		];
	}else if(/failed/gi.test(props.info.status) || props.info.error){
		message = <span>Error: {error}</span>;
		iconInfo = {
			icon: "fas fa-times-circle is-error",
			title: "Error",
		};
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${iconInfo.icon}`} title={iconInfo.title} />
		, <div key="body" className="message-body">{message}</div>
		, <Icon key="clear" name="clear" iconStyle="fal" className="clear-message" title="Clear Message" onClick={props.clearMessage} />
		, <b key="empty" />
		, <span key="footer" className="message-footer name-overflow" title={campaignName}>{campaignName}</span>
		, <time key="time" className="message-time" dateTime={props.info.timestamp}>{props.info.prettyTime}</time>
		,
	];
}
